module.exports = {
  AFRAME_INJECTED: 'aframe-injected',
  DEFAULT_CAMERA_HEIGHT: 1.6,
  animation: require('./animation'),
  keyboardevent: require('./keyboardevent')
};
